import Axios from "axios";
import {
    SET_ASSET_TRANSFER_LIST,
    UNSET_ASSET_TRANSFER_LIST,
    SET_ASSET_REGISTER_TRANSFER_LIST,
    UNSET_ASSET_REGISTER_TRANSFER_LIST,
    SET_EDITING_ASSET_TRANSFER,
    UNSET_EDITING_ASSET_TRANSFER,
} from "@/store/mutation-types";

import { saveUpdateAssetTransfer, getAssetTransferList,getAssetRegisterTransfersList, getAssetTransferById } from "@/store/api";

const state = {
    getAssetTransferList: [],
    getAssetRegisterTransfersList: [],
    getEditingAssetTransfer: null,
};

const getters = {
    getAssetTransferList(state) {
        return state.getAssetTransferList;
    },
    getAssetRegisterTransfersList(state) {
        return state.getAssetRegisterTransfersList;
    },
    getEditingAssetTransfer(state) {
        return state.getEditingAssetTransfer;
    }
};

const mutations = {
    [SET_ASSET_TRANSFER_LIST](state, data) {
        state.getAssetTransferList = data;
    },
    [UNSET_ASSET_TRANSFER_LIST](state) {
        state.getAssetTransferList = [];
    },
    [SET_ASSET_REGISTER_TRANSFER_LIST](state, data) {
        state.getAssetRegisterTransfersList = data;
    },
    [UNSET_ASSET_REGISTER_TRANSFER_LIST](state) {
        state.getAssetRegisterTransfersList = [];
    },
    [SET_EDITING_ASSET_TRANSFER](state, data) {
        state.getEditingAssetTransfer = data;
    },
    [UNSET_EDITING_ASSET_TRANSFER](state) {
        state.getEditingAssetTransfer = null;
    }
};

const actions = {
    saveUpdateAssetTransfer({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdateAssetTransfer, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },


    getAssetTransferList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(getAssetTransferList, { params: data})
                .then(function (response) {
                    commit('SET_ASSET_TRANSFER_LIST', response.data.data)
                    resolve(response);
                })
                .catch(function (error) {
                    commit('UNSET_ASSET_TRANSFER_LIST')
                    reject(error);
                })
                .then((always) => {
                });
        });
    },

    getAssetRegisterTransfersList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(getAssetRegisterTransfersList, { params: data})
                .then(function (response) {
                    commit('SET_ASSET_REGISTER_TRANSFER_LIST', response.data.data)
                    resolve(response);
                })
                .catch(function (error) {
                    commit('UNSET_ASSET_REGISTER_TRANSFER_LIST')
                    reject(error);
                })
                .then((always) => {
                });
        });
    },

    getAssetTransferById({ commit }, data) {
        const getAssetTransferRecordById = `${getAssetTransferById}/${data}`;
            commit("SET_LOADING", { color: "primary" });
            return new Promise((resolve, reject) => {
                Axios.get(getAssetTransferRecordById)
                    .then((response) => {
                    resolve(response.data); 
                })
                    .catch((error) => {
                    console.error("API Error:", error.response?.data || error.message);
                    reject(error);
                })
                    .finally(() => {
                    commit("UNSET_LOADING");
                });
            }
        );
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};






